module.exports = __webpack_public_path__ + "70184ad1d84addbb90e38b1bb601da08.png";